import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import { Box, xcss } from '@atlaskit/primitives';
import messages from './messages';
import { type Props } from './types';

const containerStyles = xcss({
	marginTop: 'space.100',
});

class CreateSpaceLink extends PureComponent<Props> {
	render() {
		const {
			intl: { formatMessage },
			onCreateSpace,
			isConnectingSpace,
		} = this.props;

		return (
			<Box xcss={containerStyles}>
				<Button
					spacing="none"
					// TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
					appearance="link"
					onClick={(_event, analyticsEvent) => onCreateSpace(analyticsEvent)}
					isDisabled={isConnectingSpace}
					data-test-id="confluence-project-pages.post-expand.connect-or-update-space-modal.create-space-link"
				>
					{formatMessage(messages.linkText)}
				</Button>
			</Box>
		);
	}
}

export default injectIntl(CreateSpaceLink);
